const kyotoWards = [
  "北区",
  "上京区",
  "中京区",
  "下京区",
  "南区",
  "東山区",
  "山科区",
  "左京区",
  "右京区",
  "西京区",
  "伏見区",
];

const surroundingSouth = [
  "宇治市",
  "亀岡市",
  "長岡京市",
  "向日市",
  "城陽市",
  "八幡市",
  "京田辺市",
  "木津川市",
  "久御山町",
  "宇治田原町",
];

const northernKyoto = [
  "福知山市",
  "舞鶴市",
  "綾部市",
  "宮津市",
  "南丹市",
  "京丹後市",
  "与謝野町",
  "伊根町",
  "丹波町",
  "美山町",
];

export default function Areas() {
  return (
    <section id="areas" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            AREA
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            <span className="text-primary-500">対応エリア</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都市全域を中心に、京都府内の幅広いエリアへ出張回収に伺います。北部エリアもご相談に応じます。
          </p>
        </div>

        <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-10">
          <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-5 flex items-center gap-2">
            <i className="ri-map-pin-line text-primary-600"></i>
            京都市（11区）
          </h3>
          <div className="flex flex-wrap gap-2 mb-8">
            {kyotoWards.map((w) => (
              <span
                key={w}
                className="px-4 py-2 rounded-full bg-primary-100 text-primary-800 text-sm font-medium whitespace-nowrap"
              >
                {w}区
              </span>
            ))}
          </div>

          <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-5 flex items-center gap-2">
            <i className="ri-map-pin-2-line text-primary-600"></i>
            京都府南部・周辺エリア
          </h3>
          <div className="flex flex-wrap gap-2 mb-8">
            {surroundingSouth.map((a) => (
              <span
                key={a}
                className="px-4 py-2 rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium whitespace-nowrap"
              >
                {a}
              </span>
            ))}
          </div>

          <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-5 flex items-center gap-2">
            <i className="ri-map-pin-3-line text-primary-600"></i>
            京都府北部
          </h3>
          <div className="flex flex-wrap gap-2">
            {northernKyoto.map((a) => (
              <span
                key={a}
                className="px-4 py-2 rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium whitespace-nowrap"
              >
                {a}
              </span>
            ))}
          </div>
        </div>

        <p className="mt-6 text-center text-xs md:text-sm text-foreground-500 leading-relaxed">
          ※上記以外のエリアもご相談ください。まずはお電話・LINEにてお問い合わせください。
        </p>
      </div>
    </section>
  );
}